import { jsx } from 'react/jsx-runtime';
import { useCallback, useEffect } from 'react';
"use strict";
const LinePaths = ({
  id,
  parentId,
  items,
  zIndex,
  elementsRef,
  strokeColor,
  spacingTop = 24
  // Half of padding top from SubNavigationTopologyContainer
}) => {
  const drawPaths = useCallback(id2 => {
    const svg = document.querySelector(`#${id2}`);
    if (!svg || !items?.length) {
      return;
    }
    const activeElement = document.querySelector(`#${parentId}`);
    const paths = svg.querySelectorAll("path");
    const parentRect = activeElement?.getBoundingClientRect();
    if (!elementsRef.current) {
      return;
    }
    paths.forEach((path, index) => {
      const element = elementsRef.current?.[index];
      const {
        top = 0,
        left = 0,
        width = 0
      } = element?.getBoundingClientRect() ?? {};
      if (!parentRect || !element) {
        return;
      }
      const x12 = parentRect.left + parentRect.width / 2;
      const y12 = parentRect.bottom;
      const x22 = left + width / 2;
      const y22 = top;
      const midX = (x12 + x22) / 2;
      const midY = (y12 + y22) / 2;
      const control1X = x12;
      const control1Y = y12 + 20;
      const control2X = x22;
      const control2Y = y22 - 25;
      const lineEndX = x22;
      const lineEndY = y22 + 20;
      const d = `
            M ${x12} ${y12} 
            Q ${control1X} ${control1Y}, ${midX} ${midY} 
            Q ${control2X} ${control2Y}, ${x22} ${y22}
            L ${lineEndX} ${lineEndY}
          `;
      path.setAttribute("d", d.trim());
    });
    const firstElement = elementsRef.current[1];
    const lastElement = elementsRef.current[paths.length - 1];
    if (!firstElement || !lastElement) {
      return;
    }
    const firstElementRect = firstElement?.getBoundingClientRect();
    const lastElementRect = lastElement?.getBoundingClientRect();
    const xOffset = 4;
    const x1 = firstElementRect.left - xOffset;
    const y1 = firstElementRect.bottom;
    const x2 = lastElementRect.left - xOffset;
    const y2 = lastElementRect.top;
    const padding = spacingTop;
    const minX = Math.min(x1, x2) - padding;
    const minY = Math.min(y1, y2) - padding;
    const maxX = Math.max(x1, x2) + padding;
    const maxY = Math.max(y1, y2) + padding;
    const viewBoxWidth = maxX - minX;
    const viewBoxHeight = maxY - minY;
    svg.setAttribute("viewBox", `${minX} ${minY} ${viewBoxWidth} ${viewBoxHeight}`);
  }, [items, parentId, elementsRef, spacingTop]);
  useEffect(() => {
    if (!items?.length || !id) {
      return;
    }
    drawPaths(id);
  }, [items, id, drawPaths]);
  return /* @__PURE__ */jsx("svg", {
    id,
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      top: `${spacingTop}px`,
      opacity: 1,
      overflow: "visible",
      transition: "opacity 0.2s ease-in-out",
      position: "absolute",
      height: "100%",
      zIndex
    },
    children: (items ?? []).map(item => /* @__PURE__ */jsx("path", {
      stroke: strokeColor
    }, `${item.id}-path`))
  });
};
export { LinePaths };
//# sourceMappingURL=LinePaths.mjs.map
